import {
    AIDisclosureParagraphEditType,
    AIDisclosureParagraphType,
} from '@/services/ai-disclosure/type/ai-disclosure.enum';
import IconShorter from '@/presentation/components/icons/IconShorter.vue';
import IconLonger from '@/presentation/components/icons/IconLonger.vue';
import IconMagicStar from '@/presentation/components/icons/IconMagicStar.vue';
import IconAddMore from '@/presentation/components/icons/IconAddMore.vue';
import IconEdit from '@/presentation/components/icons/IconEdit.vue';
import type { NavLeaf } from '@/services/ai-disclosure/type/ai-disclosure.type';

export const disclosureOptimizationTypeMap = [
    {
        icon: IconMagicStar,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.POLISH,
        labelKey: 'aiDisclosure.polish',
    },
    {
        icon: IconShorter,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.SIMPLIFY,
        labelKey: 'aiDisclosure.simplify',
    },
    {
        icon: IconLonger,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.EXPAND,
        labelKey: 'aiDisclosure.expand',
    },
    {
        icon: IconEdit,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.ADD_BACKGROUND,
        labelKey: 'aiDisclosure.addBackground',
    },
    {
        icon: IconAddMore,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.ADD_REFERENCE,
        labelKey: 'aiDisclosure.addReference',
    },
    {
        icon: IconEdit,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.ADD_DRAWBACKS,
        labelKey: 'aiDisclosure.addDrawbacks',
    },
    {
        icon: IconEdit,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.ADD_PROBLEM,
        labelKey: 'aiDisclosure.addProblem',
    },
    {
        icon: IconEdit,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.ADD_EFFECT,
        labelKey: 'aiDisclosure.addEffect',
    },
    {
        icon: IconEdit,
        disclosureParagraphEditType: AIDisclosureParagraphEditType.ADD_EMBODIMENT,
        labelKey: 'aiDisclosure.addEmbodiment',
    }
];

export const navTree: NavLeaf[] = [
    {
        type: AIDisclosureParagraphType.TECH_FIELD,
        titleKey: 'aiDisclosure.tech_field',
        noSelectionAttribute: true,
    },
    {
        type: 'parentTitleBackground',
        titleKey: 'aiDisclosure.parentTitleBackground',
        childrenTypes: [
            AIDisclosureParagraphType.BACKGROUND,
            AIDisclosureParagraphType.REFERENCE,
            AIDisclosureParagraphType.DRAWBACKS
        ],
    },
    {
        type: AIDisclosureParagraphType.BACKGROUND,
        titleKey: 'aiDisclosure.background',
        parent: 'parentTitleBackground',
        parentTitleKey: 'aiDisclosure.parentTitleBackground',
    },
    {
        type: AIDisclosureParagraphType.REFERENCE,
        titleKey: 'aiDisclosure.reference',
        parent: 'parentTitleBackground',
        parentTitleKey: 'aiDisclosure.parentTitleBackground',
    },
    {
        type: AIDisclosureParagraphType.DRAWBACKS,
        titleKey: 'aiDisclosure.drawbacks',
        parent: 'parentTitleBackground',
        parentTitleKey: 'aiDisclosure.parentTitleBackground',
    },
    {
        type: 'parentTitlePatentTarget',
        titleKey: 'aiDisclosure.parentTitlePatentTarget',
        childrenTypes: [
            AIDisclosureParagraphType.TECH_PROBLEM,
            AIDisclosureParagraphType.TECH_EFFECT
        ],
    },
    {
        type: AIDisclosureParagraphType.TECH_PROBLEM,
        titleKey: 'aiDisclosure.tech_problem',
        parent: 'parentTitlePatentTarget',
        parentTitleKey: 'aiDisclosure.parentTitlePatentTarget',
    },
    {
        type: AIDisclosureParagraphType.TECH_EFFECT,
        titleKey: 'aiDisclosure.tech_effect',
        parent: 'parentTitlePatentTarget',
        parentTitleKey: 'aiDisclosure.parentTitlePatentTarget',
    },
    {
        type: AIDisclosureParagraphType.TECH_MEANS,
        titleKey: 'aiDisclosure.tech_means',
    },
    {
        type: AIDisclosureParagraphType.EMBODIMENT,
        titleKey: 'aiDisclosure.embodiment',
    }
];
